/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'

import { Tooltip } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, object, string, bool } from 'prop-types'

import CustomRadioBoxes from 'Pods/Shared/Checkbox/CustomRadioBoxes'
import Icon from 'Pods/Shared/Icon/Icon'

import CgiModelDetails from './Components/CgiModelDetails'
import PrintableModelDetails from './Components/PrintableModelDetails/PrintableModelDetails'

function TechnicalDetailsArea({
  type,
  onTypeChange,
  onDetailsChange,
  onMultipleDetailsChange,
  cgTechDetails,
  printableTechDetails,
  showErrors = false,
  errorFor,
  aiGenerated,
  onAiGeneratedToggle,
}) {
  const types = [
    { value: 'cg', label: 'CGI model' },
    { value: 'printable', label: '3D print model' },
  ]

  return (
    <div className="publisher-area publisher-area--technical-details">
      <div className="card">
        <div className="l-inner">
          <div className="section-heading">
            Technical details
            <Tooltip
              id="technical-details-tooltip"
              content={I18n.translate('tooltips.publisher.technical_details')}
              tooltipClassName="tooltip--normal-weight"
            >
              <Icon type={['fas', 'info-circle']} color="grey" className="ml-5" />
            </Tooltip>
          </div>

          <div className="technical-details__type-selector">
            <CustomRadioBoxes options={types} selectedValue={type} onChange={onTypeChange} />

            <div className="technical-details__ai-generated-check">
              <input
                type="checkbox"
                id="ai-generated-technical"
                className="checkbox"
                checked={aiGenerated}
                onChange={onAiGeneratedToggle}
              />
              <label htmlFor="ai-generated-technical">AI generated content</label>
            </div>
          </div>

          {type === 'cg' ? (
            <CgiModelDetails
              onDetailsChange={onDetailsChange}
              cgTechDetails={cgTechDetails}
              showErrors={showErrors}
              errorFor={errorFor}
            />
          ) : (
            <PrintableModelDetails
              onDetailsChange={onDetailsChange}
              onMultipleDetailsChange={onMultipleDetailsChange}
              printableTechDetails={printableTechDetails}
              showErrors={showErrors}
            />
          )}
        </div>
      </div>
    </div>
  )
}

TechnicalDetailsArea.propTypes = {
  onDetailsChange: func.isRequired,
  onMultipleDetailsChange: func.isRequired,
  onTypeChange: func.isRequired,
  type: string.isRequired,
  cgTechDetails: object.isRequired,
  printableTechDetails: object.isRequired,
  showErrors: bool,
  errorFor: func.isRequired,
  aiGenerated: bool.isRequired,
  onAiGeneratedToggle: func.isRequired,
}

export default TechnicalDetailsArea
